import { createAppFromCommonTemplate, lazyImport } from '@helpers'
import { parseJSONSafe } from '@velasca/utils/parse-json-safe'

const { CollectionTextSection } = lazyImport(
  () => import('@velasca/ui/collection-text-section'),
  'CollectionTextSection',
)

const collectionLoginMessageEl = document.getElementById(
  'collection-login-message',
)
const collectionLoginJson = document.getElementById(
  'collection-login-message-data',
)
const collectionLoginData = parseJSONSafe(
  collectionLoginJson?.innerText || '{}',
)

export const renderCollectionTextLoginApp = () => {
  if (collectionLoginJson) {
    createAppFromCommonTemplate(
      collectionLoginMessageEl,
      <CollectionTextSection
        title={collectionLoginData.title}
        upperTitle={collectionLoginData.upperTitle}
        paragraph={collectionLoginData.paragraph}
      />,
    )
  }
}
